import { render, staticRenderFns } from "./formItemComp.vue?vue&type=template&id=4068eb6e"
import script from "./formItemComp.vue?vue&type=script&lang=js"
export * from "./formItemComp.vue?vue&type=script&lang=js"
import style0 from "./formItemComp.vue?vue&type=style&index=0&id=4068eb6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports